import {FC} from 'react';

import {Box, Stack} from '@mui/material';
import {Unmounted} from './Unmounted';

import {IServiceRequest, TypeServiceRequestStatusCode} from '../../../../shared/types/serviceRequest.types';

import {IContentTreeItem} from '../../../../shared/types/workContent.types';
import {WorkData} from '../WorkData';
import {SecondImported} from './SecondImported';

interface IInformation {
  serviceRequest: IServiceRequest;
  template: IContentTreeItem[];
}

const StackCenterStyle = {
  justifyContent: 'center',
};

const workDataAllowedStatuses: TypeServiceRequestStatusCode[] = ['IN_PROGRESS', 'EXECUTED', 'DONE', 'APPROVED'];

const Information: FC<IInformation> = ({serviceRequest, template}) => {
  const canShowWorkData =
    workDataAllowedStatuses.some((status) => serviceRequest.statusCode === status) || serviceRequest.onRevision;

  return (
    <Box>
      <Stack direction="column" spacing={2}>
        <Stack direction="row" sx={StackCenterStyle} spacing={3}>
          <Stack direction="column">
            <Unmounted serviceRequest={serviceRequest} />
          </Stack>
        </Stack>
        {serviceRequest?.hasDeviceData && (
          <Stack direction="row" sx={StackCenterStyle} spacing={3}>
            <Stack direction="column">
              <SecondImported serviceRequest={serviceRequest} />
            </Stack>
          </Stack>
        )}
        {Array.isArray(template) && canShowWorkData && <WorkData template={template} />}
      </Stack>
    </Box>
  );
};

export default Information;
